const userSite = {
  icon: 'UsersIcon',
  title: 'Site Engineers',
  subtitle: 'Manage accounts, access, QR codes, and performance insights.',
  goto: 'https://contact.gulftic.com/join/gulftic',
  gotoIcon: 'ExternalLinkIcon',
  gotoLabel: 'Open join link',
}

export default userSite
